import {useMediaQuery, useOrientation} from '@uidotdev/usehooks'
import clsx from 'clsx'
import {FC, PropsWithChildren, useMemo} from 'react'
import RotateIllustration from './rotate.svg'

interface IOrientationWatcherProps extends PropsWithChildren {
  supportSmLandscape?: boolean
  supportSmPortrait?: boolean
  supportMdLandscape?: boolean
  supportMdPortrait?: boolean
}

export const OrientationWatcher: FC<IOrientationWatcherProps> = ({
  children,
  supportSmLandscape = false,
  supportSmPortrait = false,
  supportMdLandscape = false,
  supportMdPortrait = false,
}) => {
  const {type} = useOrientation()
  const isMobile = useMediaQuery('only screen and (max-width : 767px)')

  const isSupported = useMemo(() => {
    if (isMobile) {
      if (type === 'landscape-primary' && supportSmLandscape) {
        return true
      }

      if (type === 'portrait-primary' && supportSmPortrait) {
        return true
      }
    } else {
      if (type === 'landscape-primary' && supportMdLandscape) {
        return true
      }

      if (type === 'portrait-primary' && supportMdPortrait) {
        return true
      }
    }

    return false
  }, [type, supportSmLandscape, supportSmPortrait, supportMdLandscape, supportMdPortrait])

  return children

  return (
    <>
      <div className={clsx('fixed inset-0 overflow-hidden', !isSupported && 'hidden')}>
        {children}
      </div>
      {!isSupported && (
        <div className="fixed inset-0 flex flex-col items-center justify-center">
          <div className="flex size-[240px] flex-col items-center justify-center gap-8 rounded-[32px] bg-white bg-opacity-60 p-8">
            <img src={RotateIllustration} alt="Roter enheten" className="size-[160px]" />
            <div>Vennligst roter enheten din</div>
          </div>
        </div>
      )}
    </>
  )
}
